var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"name":"editor_header"}}),_c('b-container',{staticClass:"py-5 vh-adjust"},[_c('b-overlay',{attrs:{"show":_vm.loadingShow,"no-wrap":""}}),_c('router-view')],1),_c('router-view',{attrs:{"name":"editor_footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }